import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon } from 'shared/components';
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl';

import { SCHEDULED, WALK_IN } from 'modules/queues/constants/queueTypes';
import { HOME_VISIT, IN_CLINIC } from 'modules/queues/constants/F2FTypes';
import { locationMessagesMap, NOT_SPECIFIED } from 'modules/queues/constants/locationTypes';
import { makeEstimationMessage } from 'modules/conference/selectors/etimatedTimeMessageFormattor';
import * as INTERNAL_APPOINTMENT_STATUSES from 'modules/common/constants/internalAppointmentStatuses';

import theme from './F2FPlaceholder.scss';


const Clock = () => (
  <svg width="155" height="155" viewBox="0 0 149 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M76.1029 150C116.103 150 148.529 117.574 148.529 77.5735C148.529 37.5735 116.103 5.14706 76.1029 5.14706C36.1029 5.14706 3.67647 37.5735 3.67647 77.5735C3.67647 117.574 36.1029 150 76.1029 150Z" fill="black" fillOpacity="0.5" />
    <path fillRule="evenodd" clipRule="evenodd" d="M72.5 145C112.541 145 145 112.541 145 72.5C145 32.4594 112.541 0 72.5 0C32.4594 0 0 32.4594 0 72.5C0 112.541 32.4594 145 72.5 145Z" fill="#FFFEE8" />
    <mask id="mask0" maskUnits="userSpaceOnUse" x="0" y="0" width="145" height="145">
      <path fillRule="evenodd" clipRule="evenodd" d="M72.5 145C112.541 145 145 112.541 145 72.5C145 32.4594 112.541 0 72.5 0C32.4594 0 0 32.4594 0 72.5C0 112.541 32.4594 145 72.5 145Z" fill="white" />
    </mask>
    <g mask="url(#mask0)">
      <path fillRule="evenodd" clipRule="evenodd" d="M148.68 75.4444C148.68 115.485 116.22 147.944 76.1797 147.944C36.139 147.944 3.67969 115.485 3.67969 75.4444C3.67969 35.4038 36.139 2.9444 76.1797 2.9444C116.22 2.9444 148.68 35.4038 148.68 75.4444ZM133.961 75.4446C133.961 107.355 108.092 133.224 76.1815 133.224C44.271 133.224 18.4023 107.355 18.4023 75.4446C18.4023 43.5341 44.271 17.6654 76.1815 17.6654C108.092 17.6654 133.961 43.5341 133.961 75.4446Z" fill="#28BBBD" />
      <path fillRule="evenodd" clipRule="evenodd" d="M145 72.5C145 112.541 112.541 145 72.5 145C32.4594 145 0 112.541 0 72.5C0 32.4594 32.4594 0 72.5 0C112.541 0 145 32.4594 145 72.5ZM130.279 72.5012C130.279 104.412 104.41 130.28 72.4999 130.28C40.5893 130.28 14.7207 104.412 14.7207 72.5012C14.7207 40.5906 40.5893 14.722 72.4999 14.722C104.41 14.722 130.279 40.5906 130.279 72.5012Z" fill="#007AC2" />
      <path fillRule="evenodd" clipRule="evenodd" d="M72.8683 31.6509C74.0878 31.6509 75.0764 30.6623 75.0764 29.4428C75.0764 28.2233 74.0878 27.2346 72.8683 27.2346C71.6488 27.2346 70.6602 28.2233 70.6602 29.4428C70.6602 30.6623 71.6488 31.6509 72.8683 31.6509Z" fill="#007AC2" />
      <path fillRule="evenodd" clipRule="evenodd" d="M72.8683 117.766C74.0878 117.766 75.0764 116.777 75.0764 115.557C75.0764 114.338 74.0878 113.349 72.8683 113.349C71.6488 113.349 70.6602 114.338 70.6602 115.557C70.6602 116.777 71.6488 117.766 72.8683 117.766Z" fill="#007AC2" />
      <path fillRule="evenodd" clipRule="evenodd" d="M103.044 104.518C104.264 104.518 105.252 103.529 105.252 102.31C105.252 101.09 104.264 100.102 103.044 100.102C101.825 100.102 100.836 101.09 100.836 102.31C100.836 103.529 101.825 104.518 103.044 104.518Z" fill="#007AC2" />
      <path fillRule="evenodd" clipRule="evenodd" d="M103.044 43.4246C104.264 43.4246 105.252 42.4359 105.252 41.2164C105.252 39.9969 104.264 39.0083 103.044 39.0083C101.825 39.0083 100.836 39.9969 100.836 41.2164C100.836 42.4359 101.825 43.4246 103.044 43.4246Z" fill="#007AC2" />
      <path fillRule="evenodd" clipRule="evenodd" d="M115.558 74.3387C116.777 74.3387 117.766 73.3501 117.766 72.1306C117.766 70.9111 116.777 69.9225 115.558 69.9225C114.338 69.9225 113.35 70.9111 113.35 72.1306C113.35 73.3501 114.338 74.3387 115.558 74.3387Z" fill="#007AC2" />
      <path fillRule="evenodd" clipRule="evenodd" d="M41.9542 104.518C43.1737 104.518 44.1623 103.529 44.1623 102.31C44.1623 101.09 43.1737 100.102 41.9542 100.102C40.7347 100.102 39.7461 101.09 39.7461 102.31C39.7461 103.529 40.7347 104.518 41.9542 104.518Z" fill="#007AC2" />
      <path fillRule="evenodd" clipRule="evenodd" d="M41.9542 43.4246C43.1737 43.4246 44.1623 42.4359 44.1623 41.2164C44.1623 39.9969 43.1737 39.0083 41.9542 39.0083C40.7347 39.0083 39.7461 39.9969 39.7461 41.2164C39.7461 42.4359 40.7347 43.4246 41.9542 43.4246Z" fill="#007AC2" />
      <path fillRule="evenodd" clipRule="evenodd" d="M29.4405 74.3387C30.6601 74.3387 31.6487 73.3501 31.6487 72.1306C31.6487 70.9111 30.6601 69.9225 29.4405 69.9225C28.221 69.9225 27.2324 70.9111 27.2324 72.1306C27.2324 73.3501 28.221 74.3387 29.4405 74.3387Z" fill="#007AC2" />
    </g>
    <rect x="70.5882" y="37.5" width="4.41176" height="35.2941" rx="2.20588" fill="#007AC2" />
    <rect x="108.846" y="94.0028" width="1.38551" height="41.1765" rx="0.692754" transform="rotate(121 108.846 94.0028)" fill="#00578B" />
    <path fillRule="evenodd" clipRule="evenodd" d="M60.4183 84.5274C59.179 85.3633 57.4968 85.0363 56.6609 83.797C55.825 82.5577 56.152 80.8755 57.3912 80.0396L70.2493 71.3667C71.4886 70.5308 73.1709 70.8578 74.0068 72.0971C74.8427 73.3363 74.5157 75.0186 73.2764 75.8545L60.4183 84.5274Z" fill="#007AC2" />
    <path fillRule="evenodd" clipRule="evenodd" d="M72.7941 77.2059C75.2307 77.2059 77.2059 75.2307 77.2059 72.7941C77.2059 70.3576 75.2307 68.3824 72.7941 68.3824C70.3576 68.3824 68.3824 70.3576 68.3824 72.7941C68.3824 75.2307 70.3576 77.2059 72.7941 77.2059Z" fill="#00578B" />
  </svg>
);


const propTypes = {
  intl: PropTypes.object.isRequired,
  queueType: PropTypes.string.isRequired,
  homeVisit: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  expectedTime: PropTypes.object.isRequired,
  faceToFaceType: PropTypes.string.isRequired,
  internalStatus: PropTypes.string.isRequired,
  ETTBSminutesDiff: PropTypes.number.isRequired,
  prerequisitesIncomplete: PropTypes.bool.isRequired,
};

const F2FPlaceholder = ({
  intl,
  homeVisit,
  queueType,
  permissions,
  expectedTime,
  faceToFaceType,
  internalStatus,
  ETTBSminutesDiff,
  prerequisitesIncomplete,
}) => (
  <div className={ theme.root }>
    <div className={ theme.wrap }>
      <Clock />

      <div className={ theme.title }>
        <Choose>
          <When condition={ faceToFaceType === IN_CLINIC }>
            <FormattedMessage id="Consultation.FaceToFaceType.InClinic" defaultMessage="** In clinic" />
          </When>
          <Otherwise >
            <FormattedMessage id="Patient.HomeVisitation.RightPanel.Bubble.Title" defaultMessage="** Home visitation" />
          </Otherwise>
        </Choose>
      </div>

      <If condition={ expectedTime.formattedDisplayMessage && permissions.canSeeSchedule && faceToFaceType === IN_CLINIC }>
        <div className={ theme.ettbs }>
          <Choose>
            <When condition={ prerequisitesIncomplete }>
              <FormattedMessage
                id="Appointments.WaitingRoom.PrerequisitesAreRequired"
                defaultMessage="** In order to receive a service, complete the prerequisite"
              />
            </When>
            <When condition={ expectedTime.formattedDisplayMessage && queueType === WALK_IN }>
              { makeEstimationMessage(expectedTime).formattedDisplayMessage }
            </When>
            <When condition={ expectedTime.formattedDisplayMessage && queueType === SCHEDULED && ETTBSminutesDiff < 15 }>
              { makeEstimationMessage(expectedTime).formattedDisplayMessage }
            </When>
          </Choose>
        </div>

        <Icon className={ theme.icon } name="clock-outline" />
      </If>

      <Icon
        name={ faceToFaceType === IN_CLINIC ? 'two-people' : 'home' }
        className={
          classnames(
            theme.generalIcon,
            { [theme.closedIcon]: internalStatus.status === INTERNAL_APPOINTMENT_STATUSES.CLOSED })
        }
      />


      <If condition={ faceToFaceType === IN_CLINIC }>
        <div className={ theme.footer }>
          <FormattedHTMLMessage
            id="Appointments.PatientWaitingRoom.NoNeedToWait.String"
            defaultMessage="** No need to wait here. We will contact you once the clinician is available"
          />
          <Icon className={ theme.icon } name="push-message" />
        </div>
      </If>

      <If condition={ faceToFaceType === HOME_VISIT }>
        <div className={ theme.locationField }>
          <Choose>
            <When condition={ homeVisit?.location?.type === NOT_SPECIFIED }>
              <FormattedMessage
                id="Patient.HomeVisitation.RightPanel.LocationNotSpecified"
                defaultMessage="** Address not specified"
              />
            </When>
            <Otherwise>
              <FormattedMessage
                id="Patient.HomeVisitation.RightPanel.Bubble.Address"
                defaultMessage="** At { location }:"
                values={{ location: intl.formatMessage(locationMessagesMap[homeVisit.location.type]).toLowerCase() }}
              />
              <div className={ theme.address }>{ homeVisit.location.address }</div>
            </Otherwise>
          </Choose>
        </div>
      </If>

    </div>
  </div>
);

F2FPlaceholder.propTypes = propTypes;

export default injectIntl(F2FPlaceholder);
